module.exports = __webpack_public_path__ + "../resources/images/illustration_archive-6822489688ebfbb598cb288d9962aacb.svg";